import { CubeQuerySchema } from 'shared/src/api/cube-query-schema';
import { LabeledVizSpec } from 'shared/src/api/ai-labeled-viz-types';
import { NoDataViz } from 'shared/src/api/ai-viz-types';

type LabeledVizOrNoData = LabeledVizSpec | NoDataViz;

export function encodeVizParams(query: CubeQuerySchema, labeledViz: LabeledVizOrNoData): string {
  const params = new URLSearchParams();
  params.set('q', JSON.stringify(query));
  params.set('v', JSON.stringify(labeledViz));
  return params.toString();
}

export function decodeVizParams(
  searchParams: URLSearchParams
): { query: CubeQuerySchema; labeledViz: LabeledVizOrNoData } | null {
  const qRaw = searchParams.get('q');
  const vRaw = searchParams.get('v');
  if (!qRaw || !vRaw) return null;

  try {
    const queryParsed = CubeQuerySchema.safeParse(JSON.parse(qRaw));
    if (!queryParsed.success) return null;

    const vizJson = JSON.parse(vRaw);
    const labeled = LabeledVizSpec.safeParse(vizJson);
    if (labeled.success) {
      return { query: queryParsed.data, labeledViz: labeled.data };
    }

    const noData = NoDataViz.safeParse(vizJson);
    if (noData.success) {
      return { query: queryParsed.data, labeledViz: noData.data };
    }

    return null;
  } catch {
    return null;
  }
}
